import { render, staticRenderFns } from "./TraineeSettingsModal.vue?vue&type=template&id=fba60f68&scoped=true"
import script from "./TraineeSettingsModal.vue?vue&type=script&lang=js"
export * from "./TraineeSettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba60f68",
  null
  
)

export default component.exports